require('./bootstrap');
require('./_form')
require('./_modal')
require('./_table')

// Flatpickr
import flatpckr from 'flatpickr';
window.flatpckr = flatpckr;
import 'flatpickr/dist/l10n/de';
